export default __webpack_public_path__ + "static/media/service-1-cleaning.48d42e21.png";